import { throttle } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Afterpay from 'components/Afterpay';
import PdpShopPayButton from 'components/PdpShopPayButton';
import { Component } from 'components/ScrollTo';
import ShoprunnerPdpCTA from 'components/Shoprunner/ShoprunnerPdpCTA';
import { HEADER_HEIGHT } from 'components/TopNavigationHeaderMobile';
import Product from 'models/Product';
import Variant from 'models/Variant';

import AddToCartSection from './AddToCartSection';

const SCROLL_THROTTLE = 50;
const STICKY_PADDING = 12; // this is twelve rather than theme variable so we can test scroll logic

class MobileAddToCart extends React.Component {
  updateSlideBackground = throttle(() => {
    const { sticky } = this.state;
    const $triggerSlide = this.triggerSlideRef.current;
    const { top } = $triggerSlide.getBoundingClientRect();

    if (top) {
      if (top - HEADER_HEIGHT < STICKY_PADDING) {
        if (!sticky) {
          this.setState({ sticky: true });
        }
      } else if (sticky) {
        this.setState({ sticky: false });
      }
    }
  }, SCROLL_THROTTLE);

  constructor() {
    super();

    this.state = {
      sticky: false,
    };

    this.triggerSlideRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.updateSlideBackground);
    this.updateSlideBackground();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.updateSlideBackground);
  }

  render() {
    const {
      handleClick,
      isDisabled,
      features,
      product,
      policyText,
      currentVariant,
      selectedQuantity,
      shopPayCampaignData,
    } = this.props;

    const { sticky } = this.state;

    let stickyClick = handleClick;

    if (isDisabled) {
      stickyClick = () => {
        Component.scroll('pdp-size-selector', -STICKY_PADDING);
      };
    }

    return (
      <div className="MobileAddToCart__container">
        {sticky && (
          <div className="MobileAddToCart--sticky fixed top-[60px] z-[99] -ml-6 w-full bg-white px-6 py-3 shadow-lg">
            <AddToCartSection {...this.props} handleClick={stickyClick} isDisabled={false} />
          </div>
        )}
        <div ref={this.triggerSlideRef} className="MobileAddToCart">
          <AddToCartSection {...this.props} />
        </div>

        {currentVariant && features.showShopPay && (
          <div className="my-3 flex w-full justify-center">
            <PdpShopPayButton
              currentVariant={currentVariant}
              selectedQuantity={selectedQuantity}
              shopPayCampaignData={shopPayCampaignData}
            />
          </div>
        )}

        {features.showAfterpayBeneathAddToCart && (
          <div className="MobileAddToCart__afterpay mt-3 text-center">
            <Afterpay price={product.price} masterId={product.masterId} />
          </div>
        )}

        {features.showShoprunner && <ShoprunnerPdpCTA />}

        {policyText && (
          <div className="MobileAddToCart__policy mt-3 text-center">
            <span className="MobileAddToCart__policy-text text-xs leading-normal tracking-tight">
              {policyText}
            </span>
          </div>
        )}
      </div>
    );
  }
}

MobileAddToCart.propTypes = {
  product: PropTypes.instanceOf(Product).isRequired,
  priceSource: PropTypes.oneOfType([PropTypes.instanceOf(Product), PropTypes.instanceOf(Variant)])
    .isRequired,
  handleClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  policyText: PropTypes.string,
  features: PropTypes.shape({
    showAfterpayBeneathAddToCart: PropTypes.bool,
    showShoprunner: PropTypes.bool,
    showShopPay: PropTypes.bool,
  }),
  currentVariant: PropTypes.instanceOf(Variant),
  selectedQuantity: PropTypes.number,
  shopPayCampaignData: PropTypes.shape({
    decisionId: PropTypes.string,
    variationId: PropTypes.number,
    experienceName: PropTypes.string,
    campaignName: PropTypes.string,
  }),
};

MobileAddToCart.defaultProps = {
  features: {},
  policyText: '',
};

export default MobileAddToCart;
